module.exports = __webpack_public_path__ + "assets/img/abonnemang-grannhjalpen.97bb7b5e.png";